module.exports = __webpack_public_path__ + "videos/video-1792.ae552a3.mp4";